export * from './univ-event-certification';
